/**
 * Route for `proxy-type-detection-public-private-residential-pr`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ProxyTypeDetectionPublicPrivateResidentialPrPage } from "../features/proxy-type-detection-public-private-residential-pr/ProxyTypeDetectionPublicPrivateResidentialPrPage";

export const proxyTypeDetectionPublicPrivateResidentialPrRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/proxy-type-detection-public-private-residential-pr",
	component: ProxyTypeDetectionPublicPrivateResidentialPrPage,
});

export default proxyTypeDetectionPublicPrivateResidentialPrRoute;
